
import { BarChart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";
import { useTranslation } from 'react-i18next';

export const FuturePlansSection = () => {
  const { t } = useTranslation();
  return (
    <>
      <motion.section
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <h2 className="text-2xl font-bold mb-4 text-white">{t('plans_detail.safety_net.future.title')}</h2>
        <p className="mb-4 text-white/70 leading-relaxed">
          {t('plans_detail.safety_net.future.body1')}
        </p>

        <div className="border border-[#c9a84c]/30 bg-[#c9a84c]/10 p-6 rounded-xl mb-8">
          <h3 className="font-bold text-lg mb-3 text-[#c9a84c] flex items-center gap-2">
            <BarChart className="h-5 w-5" />
            {t('plans_detail.safety_net.future.changes_title')}
          </h3>
          <p className="mb-4 text-white/70 leading-relaxed">
            {t('plans_detail.safety_net.future.changes_body1')}
          </p>
          <p className="text-white/70 leading-relaxed">
            {t('plans_detail.safety_net.future.changes_body2')}
          </p>
        </div>

        <div className="space-y-6 mb-8">
          <img
            src="/lovable-uploads/4790433b-16d1-4945-b930-d6b3a88523a1.png"
            alt={t('plans_detail.safety_net.future.img1_alt')}
            className="w-full border border-white/10 rounded-xl shadow-sm opacity-90"
          />

          <img
            src="/lovable-uploads/2e698192-d53d-49d3-a47f-31ad48a038f6.png"
            alt={t('plans_detail.safety_net.future.img2_alt')}
            className="w-full border border-white/10 rounded-xl shadow-sm opacity-90"
          />

          <div className="text-sm text-white/45 mt-2">
            {t('plans_detail.safety_net.future.source')}
            <a
              href="https://www.meti.go.jp/press/2024/11/20241128001/20241128001.html"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#c9a84c] hover:underline ml-1"
            >
              https://www.meti.go.jp/press/2024/11/20241128001/20241128001.html
            </a>
          </div>
        </div>

        <div className="border border-[#c9a84c]/30 bg-[#c9a84c]/10 p-6 rounded-xl mb-8">
          <h3 className="font-bold text-lg mb-3 text-[#c9a84c]">{t('plans_detail.safety_net.future.links_title')}</h3>
          <ul className="space-y-2">
            <li>
              <a
                href="https://www.jfc.go.jp/n/finance/search/covid_19_after.html"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#c9a84c] hover:underline text-sm"
              >
                {t('plans_detail.safety_net.future.link1_text')}
              </a>
            </li>
            <li>
              <a
                href="https://www.meti.go.jp/covid-19/index.html"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#c9a84c] hover:underline text-sm"
              >
                {t('plans_detail.safety_net.future.link2_text')}
              </a>
            </li>
            <li>
              <a
                href="https://www.fsa.go.jp/news/r6/ginkou/20241128/yousei.html"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#c9a84c] hover:underline text-sm"
              >
                {t('plans_detail.safety_net.future.link3_text')}
              </a>
            </li>
          </ul>
        </div>

        <div className="border border-white/10 bg-white/5 p-6 rounded-xl">
          <h3 className="font-bold text-lg mb-3 text-white">{t('plans_detail.safety_net.future.consult_title')}</h3>
          <p className="mb-4 text-white/65 leading-relaxed">
            {t('plans_detail.safety_net.future.consult_body')}
          </p>
          <Button
            onClick={() => window.open('https://docs.google.com/forms/d/e/1FAIpQLSfGctjmssSGu73JcGfPeECrLstNGZF5w_36ePFOZLw7s-1HPg/viewform', '_blank', 'noopener,noreferrer')}
            variant="outline"
            size="lg"
            className="border-[#c9a84c] text-[#c9a84c] hover:bg-[#c9a84c]/10 bg-transparent"
          >
            {t('plans_detail.safety_net.future.consult_button')}
          </Button>
        </div>
      </motion.section>
    </>
  );
};
